import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { organizationStateSliceReducerKey } from './organization-slice';
import type { RootState } from '@/redux/root-store';

const organization = (state: RootState) => state[organizationStateSliceReducerKey];

const getSelectedOrganization = createSelector([organization], org => org.selectedOrganization);
export const useGetSelectedOrganization = () => useSelector(getSelectedOrganization);
